/* EMA community pages (Installation Tutorials + Sponsorship).
   Plain JS, no dependencies. Safe to load on either page: every feature checks that its markup exists. */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- Dialogs ---------- */
  function openDialog(dlg) {
    if (!dlg) return;
    if (typeof dlg.showModal === 'function') {
      if (!dlg.open) dlg.showModal();
    } else {
      dlg.setAttribute('open', '');
    }
    root.classList.add('emc-lock');
  }

  function closeDialog(dlg) {
    if (!dlg) return;
    if (typeof dlg.close === 'function') dlg.close();
    else dlg.removeAttribute('open');
    afterClose(dlg);
  }

  function afterClose(dlg) {
    // Stop any playing video by removing the popup content.
    var holder = dlg.querySelector('[data-emc-pop-content]');
    if (holder) holder.innerHTML = '';
    if (!qsa('dialog.emc-dialog[open]').length) root.classList.remove('emc-lock');
  }

  qsa('dialog.emc-dialog').forEach(function (dlg) {
    dlg.addEventListener('close', function () { afterClose(dlg); });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) closeDialog(dlg); // click on the backdrop
    });
  });

  document.addEventListener('click', function (e) {
    var closeBtn = e.target.closest('[data-emc-close]');
    if (closeBtn) {
      closeDialog(closeBtn.closest('dialog'));
      return;
    }

    var tutBtn = e.target.closest('[data-emc-open]');
    if (tutBtn) {
      var tpl = document.getElementById(tutBtn.getAttribute('data-emc-open'));
      var pop = document.getElementById('emc-pop');
      if (!tpl || !pop) return;
      var holder = pop.querySelector('[data-emc-pop-content]');
      holder.innerHTML = '';
      holder.appendChild(tpl.content.cloneNode(true));
      qsa('iframe[data-src]', holder).forEach(function (f) { f.src = f.getAttribute('data-src'); });
      openDialog(pop);
      return;
    }

    var dlgBtn = e.target.closest('[data-emc-open-dialog]');
    if (dlgBtn) {
      openDialog(document.getElementById(dlgBtn.getAttribute('data-emc-open-dialog')));
    }
  });

  // Re-open a form dialog after Shopify posts it back (success message or errors).
  qsa('[data-emc-autoopen]').forEach(function (el) {
    openDialog(document.getElementById(el.getAttribute('data-emc-autoopen')));
  });

  /* ---------- Search, filters and sort ---------- */
  qsa('[data-emc-filters]').forEach(function (bar) {
    var scope = bar.closest('[data-emc-root]') || document;
    var chips = qsa('[data-emc-filter]', bar);
    var kitBtn = bar.querySelector('[data-emc-kit]');
    var clearBtn = bar.querySelector('[data-emc-clear]');
    var searchEl = bar.querySelector('[data-emc-search]');
    var state = { bike: '', q: '', diff: '', platform: '', kit: false, sort: '' };

    function matches(tile) {
      if (state.bike && tile.getAttribute('data-bike') !== state.bike) return false;
      if (state.diff && tile.getAttribute('data-diff') !== state.diff) return false;
      if (state.platform && tile.getAttribute('data-platform') !== state.platform) return false;
      if (state.kit && tile.getAttribute('data-kit') !== '1') return false;
      if (state.q) {
        var hay = tile.getAttribute('data-search') || '';
        var words = state.q.split(/\s+/);
        for (var i = 0; i < words.length; i += 1) {
          if (words[i] && hay.indexOf(words[i]) === -1) return false;
        }
      }
      return true;
    }

    function sortValue(tile) {
      if (state.sort === 'easy') return Number(tile.getAttribute('data-diff-rank')) || 9;
      if (state.sort === 'quick') return Number(tile.getAttribute('data-mins')) || 9999;
      return 0;
    }

    function apply() {
      var active = !!(state.bike || state.q || state.diff || state.platform || state.kit);
      chips.forEach(function (c) {
        c.setAttribute('aria-pressed', String(c.getAttribute('data-emc-filter') === state.bike));
      });
      if (kitBtn) kitBtn.setAttribute('aria-pressed', String(state.kit));
      if (clearBtn) clearBtn.hidden = !(active || state.sort);

      qsa('[data-emc-group]', scope).forEach(function (group) {
        var tiles = qsa('[data-emc-tile]', group);
        var shown = 0;
        tiles.forEach(function (tile, idx) {
          var ok = matches(tile);
          tile.hidden = !ok;
          if (ok) shown += 1;
          tile.__emcIdx = idx;
        });
        // Sorting uses CSS order, so the DOM (and the popups) never move.
        if (state.sort) {
          var sorted = tiles.slice().sort(function (a, b) {
            if (state.sort === 'az') {
              var ta = a.getAttribute('data-title') || '';
              var tb = b.getAttribute('data-title') || '';
              return ta < tb ? -1 : ta > tb ? 1 : 0;
            }
            return (sortValue(a) - sortValue(b)) || (a.__emcIdx - b.__emcIdx);
          });
          sorted.forEach(function (tile, n) { tile.style.order = String(n + 1); });
        } else {
          tiles.forEach(function (tile) { tile.style.order = ''; });
        }
        // "Coming soon" tile only shows with no filter; the "Add yours" tile always shows, last.
        qsa('[data-emc-placeholder]', group).forEach(function (p) { p.hidden = active; });
        qsa('[data-emc-addtile]', group).forEach(function (a) { a.style.order = state.sort ? '9999' : ''; });
        var empty = group.querySelector('[data-emc-empty]');
        if (empty) empty.hidden = !(active && shown === 0);
      });
    }

    bar.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-emc-filter]');
      if (chip) { state.bike = chip.getAttribute('data-emc-filter'); apply(); return; }
      if (e.target.closest('[data-emc-kit]')) { state.kit = !state.kit; apply(); return; }
      if (e.target.closest('[data-emc-clear]')) {
        state = { bike: '', q: '', diff: '', platform: '', kit: false, sort: '' };
        if (searchEl) searchEl.value = '';
        qsa('[data-emc-select]', bar).forEach(function (sel) { sel.value = ''; });
        apply();
      }
    });
    bar.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-emc-select]');
      if (sel) { state[sel.getAttribute('data-emc-select')] = sel.value; apply(); }
    });
    if (searchEl) {
      searchEl.addEventListener('input', function () {
        state.q = searchEl.value.toLowerCase().trim();
        apply();
      });
    }
  });

  /* ---------- Add to cart from the popup ---------- */
  function refreshCartBubble() {
    try {
      fetch(window.location.pathname + '?sections=cart-icon-bubble')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data && data['cart-icon-bubble'];
          if (!html) return;
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          // The section renders only the inside of the cart icon link (same as the theme's own cart scripts).
          var fresh = tmp.querySelector('.shopify-section') || tmp;
          var live = document.getElementById('cart-icon-bubble');
          if (live) live.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    } catch (err) { /* cart count just won't live-update */ }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-emc-add]');
    if (!btn || btn.tagName !== 'BUTTON') return;
    var items;
    try { items = JSON.parse(btn.getAttribute('data-emc-add')); } catch (err) { return; }
    if (!items || !items.length || btn.disabled) return;
    var label = btn.getAttribute('data-label') || btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      btn.textContent = 'Added \u2713';
      var link = btn.parentNode.querySelector('[data-emc-cartlink]');
      if (link) link.hidden = false;
      refreshCartBubble();
      setTimeout(function () { btn.disabled = false; btn.textContent = label.trim(); }, 4000);
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = 'Could not add. Try again';
      setTimeout(function () { btn.textContent = label.trim(); }, 3500);
    });
  });

  /* ---------- Sponsor rules fold: links to #emc-rules open it ---------- */
  var rulesBox = document.querySelector('[data-emc-rules]');
  function openRules() {
    if (!rulesBox) return;
    rulesBox.open = true;
    setTimeout(function () { rulesBox.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' }); }, 30);
  }
  if (rulesBox) {
    if (window.location.hash === '#emc-rules') rulesBox.open = true;
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href="#emc-rules"]');
      if (a) { e.preventDefault(); openRules(); }
    });
  }

  /* ---------- Subtle 3D tilt on hover (desktop pointers only) ---------- */
  if (!reduceMotion && window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    qsa('.emc-tile:not(.emc-tile--add)').forEach(function (tile) {
      var card = tile.querySelector('.emc-tile__card');
      if (!card) return;
      tile.addEventListener('pointermove', function (e) {
        var r = tile.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        card.style.setProperty('--ry', (x * 5).toFixed(2) + 'deg');
        card.style.setProperty('--rx', (-y * 5).toFixed(2) + 'deg');
      });
      tile.addEventListener('pointerleave', function () {
        card.style.setProperty('--ry', '0deg');
        card.style.setProperty('--rx', '0deg');
      });
    });
  }

  /* ---------- Scroll reveal ---------- */
  var reveals = qsa('.emc-reveal');
  if ('IntersectionObserver' in window && !reduceMotion) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('is-in');
          io.unobserve(en.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- Form helpers ---------- */
  // Handles: strip a leading @ and spaces as people type or paste.
  qsa('input[name="contact[Creator handle]"], input[name="contact[Social handle]"]').forEach(function (inp) {
    inp.addEventListener('input', function () {
      var clean = inp.value.replace(/^@+/, '').replace(/\s+/g, '');
      if (clean !== inp.value) inp.value = clean;
    });
  });
  // Sponsor code: letters/numbers only, uppercase.
  qsa('input[data-emc-code]').forEach(function (inp) {
    inp.addEventListener('input', function () {
      var clean = inp.value.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
      if (clean !== inp.value) inp.value = clean;
    });
  });
})();
